import { prop } from "@rxweb/reactive-form-validators";

export class ConvertOppToLeadContactItem {
    contactId: number;
    contactName: string = '';
    contactLastName: string = '';
    contactEmail: string;
    contactPhone: string;
    selected: boolean = true;
    isExistLead: boolean = false;
    existLeadId: string = null;

    constructor(contact?: any) {
        if (contact) {
            this.contactId = contact.contactId;
            this.contactName = contact.contactName || '';
            this.contactLastName = contact.contactLastName || '';
            this.contactEmail = contact.contactEmail || '';
            this.contactPhone = contact.contactPhone || '';
        }
    }
}

export class ConvertOppToLeadInputModel {
    constructor() {
        this.leadSource = '';
        this.tags = '';
        this.leadInterest = 'Cold Lead';
        this.typeName = 'LEADS';
    }

    @prop()
    opportunityId: string;

    @prop()
    opportunityName: string;

    @prop()
    contacts: ConvertOppToLeadContactItem[];

    @prop()
    leadSource: string;

    @prop()
    tags: string;

    @prop()
    leadInterest: string;

    @prop()
    typeName: string;
}
